




































































































































































































































































































import Vue, { PropType } from "vue";
import ClickOutside from "vue-click-outside";
import { notificationsLink } from "@/utils/linkUtils";
import { getUserNickName } from "@/utils/labelUtils";
import { sortedByDateDesc } from "@/utils/momentUtils";

import { checkReviewTimeLimit } from "@/api/Review";
import { UserProfile } from "@/api/dto/UserProfile";
import { NotificationsResponse } from "@/api/dto/Notification";
import { getNotifications, updateReadNotifications } from "@/api/Notification";
import { defaultIconUrl } from "@/properties";
import { getUserProfile } from "@/api/UserProfile";

export default Vue.extend({
  name: "NavigationBar",
  props: {
    loginData: Object as PropType<UserProfile>,
    logged: Boolean, // ログイン状態
    current: String, //現在のページ
    mq: String,
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      defaultIconUrl,
      notifPop: false,
      notificationsData: [] as NotificationsResponse[],
      notificationListSize: 3,
      mypagePop: false,
      mypageSlide: false,
      hasUnreadNotifications: false,
      isFreeTime: false,
    };
  },
  mounted() {
    this.checkReviewTimeLimit();
    this.getNotifications();
    this.getIsFreeTime();
    if (this.loginData.userCategory === "3") {
      document.getElementById("header")!.style.background = "#fff url()";
    }
  },
  computed: {
    popNotifications(): NotificationsResponse[] {
      return this.notificationsData.slice(0, this.notificationListSize);
    },
    nickname(): string {
      return getUserNickName(this.loginData.nickname, this.loginData.userId);
    },
    corporationIcon(): string {
      return this.loginData.corporationsData.iconUrl;
    }
  },
  watch: {
    mq() {
      if (this.mq == "sp") {
        this.notifPop = false;
        this.mypagePop = false;
      } else {
        this.mypageSlide = false;
      }
    },
    notificationsData() {
      this.hasUnreadNotifications = this.notificationsData.some((notification) => !notification.isRead);
    },
    $route() {
      if (this.logged) {
        this.checkReviewTimeLimit();
        this.getNotifications();
        this.getIsFreeTime();
      }
    },
    'profileData.userCategory' (userCategory: string) {
      if (userCategory === "3") {
        document.getElementById("header")!.style.background = "#fff url()";
      }
    },
  },
  methods: {
    toggleNotif() {
      if (this.mq != "sp") {
        this.notifPop = !this.notifPop;
      } else {
        this.onPushPath("/mypage");
      }
      if (this.hasUnreadNotifications) {
        this.updateReadNotifications();
      }
    },
    notifOff() {
      this.notifPop = false;
    },
    async checkReviewTimeLimit() {
      if (!this.logged) {
        return;
      }
      await checkReviewTimeLimit();
    },
    async getNotifications() {
      if (!this.logged) {
        return;
      }
      const notifications = await getNotifications();
      this.notificationsData = sortedByDateDesc(notifications, (it) => it.date);
    },
    async updateReadNotifications() {
      const notifications = await updateReadNotifications();
      this.notificationsData = sortedByDateDesc(notifications, (it) => it.date);
    },
    async getIsFreeTime() {
      const userProf = await getUserProfile();
      this.isFreeTime = userProf.isFreeTime;
    },
    notificationsLink,
    toggleMypage() {
      if (this.mq != "sp") {
        this.mypagePop = !this.mypagePop;
      } else {
        this.mypageSlide = !this.mypageSlide;
      }
    },
    mypageOff() {
      this.mypagePop = false;
    },
    logout() {
      this.$store.dispatch("logout");
      document.getElementById("header")!.style.background = "#fff url(/images/common/header_bg.svg)";
      this.$router.push({ name: "Top" }, () => {});
    },
    onPushMode(mode: string) {
      this.$store.commit("setMode", { mode: mode });
    },
    onPushPath(path: string) {
      this.$router.push(path, () => {}); // eslint-disable-line
      this.$emit("pushPath", path);
    },
  },
});
